module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NV26_1SA_GSK.c2d0ac22.png";